import React from "react";
import InventorySlot from "./InventorySlot";

export default function InventoryGrid({ zone, columns, count, items, renderSlotContent }) {
    return (
        <div className={`vip-sim-grid-wrap vip-sim-grid-wrap--${zone}`}>
            <div
                className={`vip-sim-grid vip-sim-grid--${zone}`}
                style={{ gridTemplateColumns: `repeat(${columns}, var(--vip-slot-size))` }}
            >
                {Array.from({ length: count }, (_, i) => {
                    const placement = items[i];
                    return (
                        <InventorySlot key={`${zone}-${i}`} zone={zone} index={i}>
                            {renderSlotContent(placement, i)}
                        </InventorySlot>
                    );
                })}
            </div>
        </div>
    );
}
